<div class="form-group" *ngIf="_filter" [formGroup]="form">
    <label class="required">{{ _filter.displayName }}</label>
    <ng-container *ngIf="isFilterValue; else valueList">
        <ng-container *ngIf="_filter.usesPaginatedFilterValues(); else localSelect">
            <app-filter-values-select
                [filter]="_filter"
                [multiple]="true"
                [formControlName]="_filter.getCode()"
                [isInvalid]="form.get(_filter.getCode()).invalid && form.get(_filter.getCode()).touched"
                [withOffers]="withOffers"
                [platform]="platform"
            ></app-filter-values-select>
        </ng-container>
        <ng-template #localSelect>
            <app-select
                [options]="filterValues"
                [multiple]="true"
                [formControlName]="_filter.getCode()"
                [isInvalid]="form.get(_filter.getCode()).invalid && form.get(_filter.getCode()).touched"
            ></app-select>
        </ng-template>
    </ng-container>
    <ng-template #valueList>
        <div class="mb-1 input-group" *ngFor="let f of getValues(); let i = index" [formGroup]="f">
            <input
                [type]="inputType"
                class="form-control"
                formControlName="value"
                [class.is-invalid]="f.get('value').invalid && f.get('value').touched"
            />
            <ng-container *ngIf="i !== getValues().length - 1; else addButton">
                <button class="btn btn-outline-danger" type="button" (click)="removeValue(i)">
                    <i class="bi fs-4 bi-x"></i>
                </button>
            </ng-container>
            <ng-template #addButton>
                <button class="btn btn-outline-secondary" type="button" (click)="addValue()">
                    <i class="bi fs-4 bi-plus"></i>
                </button>
            </ng-template>
        </div>
    </ng-template>
</div>
